import { PropertyDetails } from "./types";

export const getMostRecentAppeal = (details: PropertyDetails | undefined) => {
	if (!details?.appeals) return;
	return details?.appeals.find(appeal => {
		return appeal.appeal_id === details.appeal_id;
	});
};
